import React, { useEffect, useState } from 'react';
// Shared module-level countdown state — both the top bar and the urgency module subscribe to this
let sharedSeconds = 14 * 60 + 59; // 14:59 in seconds
const subscribers = new Set<(value: number) => void>();
let intervalStarted = false;
function startGlobalInterval() {
  if (intervalStarted) return;
  intervalStarted = true;
  setInterval(() => {
    sharedSeconds = sharedSeconds <= 0 ? 14 * 60 + 59 : sharedSeconds - 1;
    subscribers.forEach(cb => cb(sharedSeconds));
  }, 1000);
}
export function useSharedCountdown() {
  const [seconds, setSeconds] = useState(sharedSeconds);
  useEffect(() => {
    startGlobalInterval();
    subscribers.add(setSeconds);
    setSeconds(sharedSeconds);
    return () => {
      subscribers.delete(setSeconds);
    };
  }, []);
  return seconds;
}
export function CountdownTimer() {
  const timeLeft = useSharedCountdown();
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <span className="font-black text-white bg-black/40 rounded px-2 py-0.5 tracking-widest text-sm md:text-base" data-id="element-342">
      {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
    </span>;
}